<template>
	<AppTabs v-model="selectedTab" class="width-100 height-100" :tabItems="tabItems" />
</template>

<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import * as WorkflowNodeService from '@/utils/workflow-node-service';
import { getNode } from '@/store/modules/nodes/getters';
import { flatPreviousSteps } from '@/store/modules/selectedNode/getters';
import SlackNotificationTab from '@/components/BlockEditorNotification/PreviewTabs/SlackNotificationTab.vue';
import EmailNotificationTab from '@/components/BlockEditorNotification/PreviewTabs/EmailNotificationTab.vue';
import PlyInboxNotificationTab from '@/components/BlockEditorNotification/PreviewTabs/PlyInboxNotificationTab.vue';
import { getAction } from '@/store/modules/actions/getters';

const EMAIL_ACTION_KEY = 'send_email_notification';

export default {
	name: 'NotificationPreview',
	props: {
		notification: { type: Object, required: true },
	},
	components: {},
	computed: {
		...mapGettersShorthand({ flatPreviousSteps, getNode, getAction }),
		notificationPreviewProps() {
			const channelNodes = (this.notification.channel_configs || []).map(({ node }) => this.getNode(node));
			const emailNode = channelNodes?.find(({ action } = {}) => this.getAction(action)?.key === EMAIL_ACTION_KEY);
			const { sender, recipient } = emailNode?.params_map || {};
			const icon = this.notification.icon;
			return { ...WorkflowNodeService.getNotificationTranslatedProps(this.notification, this.flatPreviousSteps), sender, recipient, icon };
		},
		tabItems() {
			return [
				{
					tab: 'Ply inbox',
					title: 'Preview for Ply inbox',
					tabIconWidth: '14',
					tabIconHeight: '14',
					tabIcon: 'notification-tab-inbox',
					component: PlyInboxNotificationTab,
					props: this.notificationPreviewProps,
				},
				{
					tab: 'Email',
					title: 'Preview for Email',
					tabIconWidth: '17',
					tabIconHeight: '14',
					component: EmailNotificationTab,
					tabIcon: 'notification-tab-email',
					props: this.notificationPreviewProps,
				},
				{
					tab: 'Slack',
					title: 'Preview for Slack',
					tabIconWidth: '15',
					tabIconHeight: '15',
					component: SlackNotificationTab,
					tabIcon: 'notification-tab-slack',
					props: this.notificationPreviewProps,
				},
			];
		},
	},
	data() {
		return { selectedTab: 0 };
	},
};
</script>

<style scoped lang="scss">
::v-deep {
	.app-tabs {
		max-height: 60px !important;
	}
	&.v-tabs {
		max-height: 60px !important;
	}
	.v-tabs-bar {
		height: 60px !important;
	}
	.v-tab {
		min-width: 120px !important;
	}
	.tabs_comp.v-tabs .v-tab {
		font-size: 14px !important;
		text-transform: none !important;
	}
}
</style>
